import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonsModule } from 'axis-components/components/button/button.module';
import {
  MediaComponent,
  MediaBodyComponent,
  MediaLeftComponent,
  MediaRightComponent
} from './media.component';
import { IconModule } from 'axis-components/components/icon/icon.module';

@NgModule({
  imports: [
    ButtonsModule,
    CommonModule,
    IconModule
  ],
  declarations: [
    MediaComponent,
    MediaBodyComponent,
    MediaLeftComponent,
    MediaRightComponent
  ],
  exports: [
    MediaComponent,
    MediaBodyComponent,
    MediaLeftComponent,
    MediaRightComponent
  ],
  providers: []
})
export class MediaModule { }
